module.exports = __webpack_public_path__ + "static/img/15.a629ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/15.png
// module id = WV2x
// module chunks = 0